import PlotModal from './PlotModal';

export default PlotModal;
